export const handleExportBICECsv = async (
  payments: any,
  id: any,
  message?: string,
) => {
  const filename = `Bice_${id}_${new Date().toDateString()}.csv`;

  const registries = payments.map((x: any) => {
    return {
      businessDestinationName: x.businessDestinationName,
      businessDestinationIdentifier: x.businessDestinationIdentifier.replace(
        '-',
        '',
      ),
      businessDestinationNumber: x.bankAccountDestinationNumber,
      amount: x.amount,
      bankCode: x.bankAccountDestinationBankCode,
      firstNumber: '1',
      secondNumber: '0',
      thirdNumber: '1',
      forthNumber: '1',
      operationNumber: x.sourceId,
      destinationHolderEmail: x.bankAccountDestinationHolderEmail,
    };
  });

  let parsedData = '';

  for (const registry of registries) {
    const row = Object.values(registry).join(',') + '\n';
    parsedData += row;
  }

  const csvContent = `data:text/csv;charset=utf-8,${parsedData}`;
  const encodedURI = encodeURI(csvContent);

  const a = document.createElement('a');
  a.href = encodedURI;
  a.download = filename;
  a.click();
};
